const MAX_CACHE_ENTRIES = 500

const translationCache = new Map<string, string>()

export function getCachedTranslation(key: string) {
  if (!translationCache.has(key)) {
    return
  }

  const value = translationCache.get(key)!
  translationCache.delete(key)
  translationCache.set(key, value)
  return value
}

export function setCachedTranslation(key: string, value: string) {
  if (translationCache.has(key)) {
    translationCache.delete(key)
  }

  translationCache.set(key, value)

  if (translationCache.size <= MAX_CACHE_ENTRIES) {
    return
  }

  const oldestKey = translationCache.keys().next().value
  if (oldestKey) {
    translationCache.delete(oldestKey)
  }
}

export function clearTranslatedNoteContentCacheForTests() {
  translationCache.clear()
}
